// extracted by mini-css-extract-plugin
export var root = "Y_x5";
export var wrapper = "Y_qm";
export var image = "Y_sp d_w d_y d_W";
export var imageWithHeight = "Y_x6";
export var crop = "Y_x7";
export var round = "Y_x8";
export var fixedHeight = "Y_x9";